if (!customElements.get('top-picks')) {
  customElements.define(
    'top-picks',
    class TopPicks extends HTMLElement {
      constructor() {
        super();
        this.viewAll = this.querySelector('.top-picks__view-all');
        if (this.viewAll) {
          this.viewAll.addEventListener('click', this.toggle.bind(this));
        }

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.querySelectorAll('.top-picks__add-to-cart').forEach((button) => {
          button.addEventListener('click', this.onAddToCart.bind(this));
        });
      }

      toggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.viewAll.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      onAddToCart(evt) {
        const button = evt.currentTarget;
        const variantId = button.dataset.variantId;
        if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'top-picks',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'top-picks',
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
